import React from 'react'
import MenuContainer from './MenuContainer.js'
import AppBar from '@material-ui/core/AppBar'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
	heading: {
      paddingTop: theme.spacing.unit * 2
   },
   headingText: {
      flex: 1,
      maxHeight: '120px',
      overflowY: 'auto',
      overflowX: 'auto',
      color: theme.palette.primary.textColor,
      backgroundColor: theme.palette.primary.main
      // textShadow: '2px 2px 4px #000000'
   }
})

const Header = ({ classes }) => (
   <AppBar className="Header" style={{maxHeight:200}} position="sticky">      
      <Typography  variant="display1" color="inherit" align="center" className={classes.heading}><div className={classes.headingText}>Hitta stompunkt</div></Typography>
      <MenuContainer />
   </AppBar>
)

export default withStyles(styles)(Header)



// WEBPACK FOOTER //
// ./src/components/Header/Header.js